/**
 * Created by Andrey Popov on 28.04.2025
 */

const QuestsDataSource = function (quests) {
    cleverapps.EventEmitter.call(this);

    this.quests = quests;

    this.quests.on("questAdded", this.handleQuestAdded.bind(this), this);
    this.quests.on("afterQuestAdded", this.handleQuestProgressChanged.bind(this), this);
    this.quests.on("questRemoved", this.handleQuestRemoved.bind(this), this);
    this.quests.on("questProgressChanged", this.handleQuestProgressChanged.bind(this), this);
};

QuestsDataSource.prototype = Object.create(cleverapps.EventEmitter.prototype);
QuestsDataSource.prototype.constructor = QuestsDataSource;

QuestsDataSource.prototype.getData = function () {
    return this.quests.quests.filter((quest) => !quest.isFresh()).map(this.createRow.bind(this));
};

QuestsDataSource.prototype.handleQuestAdded = function (quest) {
    this.trigger("add", this.createRow(quest));
};

QuestsDataSource.prototype.handleQuestRemoved = function (quest) {
    this.trigger("remove", quest.id);
};

QuestsDataSource.prototype.createRow = function (quest) {
    return {
        id: quest.id,
        weight: this.calcWeight(quest),
        data: quest,
        ViewCtor: quest.dynamic && quest.dynamic.rowCtor
    };
};

QuestsDataSource.prototype.calcWeight = function (quest) {
    if (quest.id.startsWith("hungrygames_order")) {
        return 100000;
    }

    let weight = this.quests.quests.indexOf(quest) + 100 * quest.progress;
    if (quest.isFinished()) {
        weight += 1000;
    }
    return weight;
};

QuestsDataSource.prototype.handleQuestProgressChanged = function () {
    this.trigger("reorder");
};

QuestsDataSource.prototype.destructor = function () {
    runCleaners(this);
};
